module.exports = __webpack_public_path__ + "static/img/tap_function-airplus_se-cn.2ee2d60.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/airplus_se/tap_function-airplus_se-cn.gif
// module id = pj2z
// module chunks = 1